module.exports = __webpack_public_path__ + "static/media/case2.52906ac7.jpg";